import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, map, tap } from 'rxjs';

import { ILoginResponse } from '@core/models/interfaces/login-response.interface';
import { Login } from '@core/models/login.model';
import { environment } from '@env/environment';
import { ILoginRequestDto } from '@pages/login/login-request.dto';
import { LocalStorageService } from '@services/storage/local-storage.service';
import { AuthStateService } from './auth-state.service';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  url = `${environment.endpoint.api}/user`;
  httpClient: HttpClient = inject(HttpClient);

  localStorageService: LocalStorageService = inject(LocalStorageService);
  authStateService = inject(AuthStateService);

  public login(data: ILoginRequestDto): Observable<Login> {
    return this.httpClient.post<ILoginResponse>(`${this.url}/login`, data).pipe(
      map(response => new Login(response)),
      tap((data: Login) => {
        this.clearRegisterData();
        this.setLoginLocalStorage(data);
        this.authStateService.set(true);
      })
    );
  }

  public clearRegisterData(): void {
    this.localStorageService.remover('register');
  }

  public setLoginLocalStorage(data: Login): void {
    this.localStorageService.set('token', data.token);
    this.localStorageService.set('user', {
      ...data.additionalInformation,
    });
  }

  public logout(): Observable<void> {
    return this.httpClient.post<void>(`${this.url}/logout`, null).pipe(
      tap(() => {
        this.removeLoginLocalStorage();
        this.authStateService.set(false);
      })
    );
  }

  public removeLoginLocalStorage(): void {
    this.localStorageService.remover('token');
    this.localStorageService.remover('user');
  }
}
